// Handles milestone completion across the site, as needed. Give 'em a little
// encouragement when they're doing good. Should primarily use okevents.
// -----------------------------------------------------------------------------

import _strf from "shared/util/_strf";

window.QuestionMilestones = {
	thresholds: [ 25, 50, 100 ],
	numAnswered: 0,

	/*
	 * Open a feedback banner with a congrats for having answered X questions.
	 *
	 * @param {Number} num - the number of questions the user has answered
	 */
	notify(num) {
		FeedbackBanner.open({
			type: "success",
			timeout: 3000,
			message: _strf(
				"Better matches unlocked! You’ve answered $num questions.",
				{ num },
			),
		});
	},

	/*
	 * Update the number of questions the user has answered, and call notify if
	 * appropriate.
	 *
	 * @param {Number} num - the number of questions the user has answered
	 */
	updateCount(num) {
		this.numAnswered = num;

		if (this.thresholds.indexOf(num) >= 0) {
			this.notify(num);
		}
	},
};



// WEBPACK FOOTER //
// ./src/legacy/milestones.js